import {action, computed, makeObservable, observable, toJS} from 'mobx';
import moment from 'moment';

import {Task} from './gantt/task';
// import {showComunicationAlert} from '../../../helpers/alerts';
// import {addingToArray, toggleInArrayImmutable} from '../../../../../../GamaCarsApiClient/helpers/helpers';
import {CarWithUsageDto, GroupedCalendarDto} from '../../../../../../PRMGApiClient';
// import {cappState} from '../../../CAppState';
// import {SearchPanelState} from '../searchPanel/SearchPanelState';

export enum ViewMode {
  QuarterDay = 'Quarter Day',
  HalfDay = 'Half Day',
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
}

export type CalendarItem = {
  id: string;
  carId: number;
  index: number;
  name: string;
  start: string;
  end: string;
  progress: number;
  custom_class?: string;
  plateNumber: string;
};

export type carDatesRange = {
  start: string;
  end: string;
};

export enum PopUpType {
  load,
  new,
}

const GanttDateFormat = 'YYYY-MM-DD';

export function formatDateForGantt(d: Date | undefined): string {
  return moment(d ?? new Date()).format(GanttDateFormat);
}

export class CalendarBoxState {
  @observable
  open: boolean = true;

  @observable
  openAccordionItem: number = 0;

  @observable
  viewMode: ViewMode = ViewMode.Day;

  @observable
  begins: string = '';

  @observable
  ends: string = '';

  @observable
  plateNumber: string | undefined = '';

  @observable
  selectedPlates: string[] = [];

  @observable
  calendarList: GroupedCalendarDto[] = [];

  @observable
  calendarListTasks = new Map<string, CalendarItem[]>(); //number =cardId,

  @observable
  carDatesArr: carDatesRange[] = [];

  @observable
  emptyDatesArr: carDatesRange[] = [];

  @observable
  basicDate: Date = moment(new Date()).startOf('month').toDate();

  @observable
  width: number = 1200;

  @observable
  height: number = 763;

  constructor() {
    makeObservable(this);
    // this.searchPanelState = new SearchPanelState(cappState.commonData?.carMakesWithModels ?? [], true);
    this.setSearchingDatesRange();
    this.createEmptyCalendarWithFakeRow();
  }

  @action
  changeViewMode(v: ViewMode) {
    this.viewMode = v;
    this.setSearchingDatesRange();
  }

  @computed
  get unit(): string {
    return this.viewMode === ViewMode.Day ? 'month' : 'year';
  }

  @computed
  get windowRange(): boolean {
    return window.innerWidth > 2000;
  }

  @computed
  get daysInMonth(): number {
    return moment(this.basicDate).daysInMonth();
  }

  @action
  setSearchingDatesRange(): void {
    // @ts-ignore
    this.begins = moment(this.basicDate).startOf(this.unit).format(GanttDateFormat);
    // @ts-ignore
    this.ends = moment(this.basicDate).endOf(this.unit).format(GanttDateFormat);
    // this.getCalendarList();
  }

  @action
  loadNextDate(b: boolean): void {
    b
      ? // @ts-ignore
        (this.basicDate = moment(this.basicDate).add(1, this.unit).toDate())
      : // @ts-ignore
        (this.basicDate = moment(this.basicDate).subtract(1, this.unit).toDate());
    this.setSearchingDatesRange();
    // this.getCalendarList();
  }

  createEmptyCalendarWithFakeRow() {
    this.calendarListTasks = new Map<string, CalendarItem[]>();
    const fakeRow: CalendarItem = {
      id: 'new',
      carId: 0,
      plateNumber: '_',
      index: 0,
      name: '',
      start: this.begins,
      end: this.ends,
      progress: 100,
      custom_class: 'empty',
    };
    const fakeArr: CalendarItem[] = [];
    fakeArr.push(fakeRow);
    this.calendarListTasks.set('_', fakeArr);
  }

  // @action
  // getCalendarList(): void {
  //   Api.Calendar.apiCalendarReservedBeginsEndsGet({
  //     begins: this.begins,
  //     ends: this.ends,
  //     plateNumbers: this.selectedPlates,
  //   })
  //     .then((res) => {
  //       runInAction(() => {
  //         this.calendarList = res?.content ?? [];
  //         this.calendarListTasks = new Map<string, CalendarItem[]>();

  //         if (this.calendarList.length === 0) {
  //           this.createEmptyCalendarWithFakeRow();
  //         }

  //         //renderujemy elementy
  //         for (const r of this.calendarList) {
  //           const plateNumber = r.plateNumber ?? '';
  //           const carRow: CalendarItem[] = [];
  //         //   //przypadek 1 - wiersz jest pusty - api zwraca pustą tablice, tworzymy zatem fakowy obiekt
  //         //   if (r.calendarItems?.length === 0) {
  //         //     carRow.push({
  //         //       id: 'new',
  //         //       carId: r.carId ?? 0,
  //         //       index: this.selectedPlates.indexOf(plateNumber),
  //         //       name: '+',
  //         //       start: this.begins,
  //         //       end: this.ends,
  //         //       progress: 100,
  //         //       custom_class: 'new',
  //         //       plateNumber: plateNumber,
  //         //     });
  //         //   }

  //           r.calendarItems?.forEach((r) => {
  //             carRow.push({
  //               id: r.reservationId?.toString() ?? '',
  //               carId: r.carId ?? 0,
  //               index: this.selectedPlates.indexOf(plateNumber),
  //               name:
  //                 (this.viewMode === ViewMode.Day && moment(r.end).diff(moment(r.start), 'days') > 8) ||
  //                 (this.viewMode === ViewMode.Month && moment(r.end).diff(moment(r.start), 'months') > 8)
  //                   ? r.name ?? plateNumber
  //                   : plateNumber,
  //               start: formatDateForGantt(r.start),
  //               end: formatDateForGantt(r.end),
  //               progress: 100,
  //               custom_class:
  //                 r.type === ReservationType.Service
  //                   ? r.type
  //                   : r.calendarColorRGB
  //                   ? 'cc-' + r.calendarColorRGB.replace('#', '')
  //                   : r.type,
  //               plateNumber: plateNumber,
  //             });
  //           });

  //           const rowWithFilledPlaceholders: CalendarItem[] = []; //tworzymy nową tablicę
  //           const index = this.selectedPlates.indexOf(plateNumber);
  //           //przypadek 2 - wiersz ma x elementów
  //           carRow.forEach((el, i) => {
  //             if (i === 0) {
  //               //pierwszy element tablicy, dodajemy więc przed nim coś
  //               rowWithFilledPlaceholders.push(
  //                 this.emptyCalendarItem(
  //                   r.carId ?? 0,
  //                   plateNumber,
  //                   index,
  //                   this.begins, //zaczynamy domyslnie minus ileś dni
  //                   moment(el.start).add(-1, 'days').format(GanttDateFormat)
  //                 ) //kończymy dzień przed tym
  //               );
  //             }

  //             rowWithFilledPlaceholders.push(el); //no i dodajemy nasz aktualny element
  //             //no i dodajemy następujący element
  //             const currentEndDate = el.end;
  //             const nextStartDate = i < carRow.length - 1 ? moment(carRow[i + 1]?.start).add(-1, 'days') : this.ends; // jak nie ma następnej daty to dajemy domyślną ilość dni
  //             const newStartDate = moment(currentEndDate).add(1, 'days').format(GanttDateFormat);
  //             const newEndDate = moment(nextStartDate).format(GanttDateFormat);

  //             //jeśli ilość dni jest większa od 1 dodajemy element
  //             if (moment(newEndDate).diff(moment(newStartDate), 'days') >= 0) {
  //               rowWithFilledPlaceholders.push(
  //                 this.emptyCalendarItem(
  //                   r.carId ?? 0,
  //                   plateNumber,
  //                   index,
  //                   newStartDate, //dodajemy jeden dzień od dzisiejszego
  //                   newEndDate
  //                 )
  //               );
  //             }
  //           });

  //           this.calendarListTasks.set(plateNumber, rowWithFilledPlaceholders);
  //         }

  //         //console.debug('Po', toJS(this.calendarListTasks));
  //       });
  //     })
  //     .catch((e: unknown) => showCommunicationError(e));
  // }

  @action
  clearCalendarData(re: string, pl: string | undefined): void {
    this.calendarListTasks.delete(re);
    this.plateNumber = pl;
  }

  @action
  carSearch(n: CarWithUsageDto) {
    if (n.plateNumber !== undefined && n.plateNumber !== null) {
      this.plateNumber = n.plateNumber;
      this.selectedPlates.push(n.plateNumber);
    } else {
      this.plateNumber = undefined;
    }
  }

  @computed
  get calendarTaskList(): Task[] {
    return Array.from(toJS(this.calendarListTasks).values()).flat() as unknown as Task[];
  }

  @action
  setWidth(w: number): void {
    this.width = w;
  }

  @action
  setHeight(h: number): void {
    this.height = h;
  }
}
